"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = void 0;
const MINIMUM_RETRY_DELAY = 1000;
const MAXIMUM_RETRY_DELAY = 4000;
const MAXIMUM_ATTEMPTS_COUNT = 3;
const RETRY_WHEN_THROTTLED = true;
class Configuration {
    constructor(token, baseUrl, options) {
        let constructorOptions = options.MCS || options || {};
        this.region = constructorOptions.region || options.region;
        this.baseUrl = baseUrl;
        this.token = token;
        this.retryWhenThrottledOverride = constructorOptions.retryWhenThrottledOverride;
        this.backoffConfigOverride = constructorOptions.backoffConfigOverride;
    }
    static get backoffConfigDefault() {
        return {
            min: MINIMUM_RETRY_DELAY,
            max: MAXIMUM_RETRY_DELAY,
            maxAttemptsCount: MAXIMUM_ATTEMPTS_COUNT
        };
    }
    static get retryWhenThrottledDefault() { return RETRY_WHEN_THROTTLED; }
    updateToken(token) {
        this.token = token;
    }
}
exports.Configuration = Configuration;
